import React, { useMemo } from "react";

import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";

import {
  getDashboardRoute,
  getLoadsRoute,
  getUserOverviewRoute,
} from "lib/navigation";

import {
  getActiveRole,
  getIsAuthenticated,
  getIsDefaultRoleTransporter,
} from "selectors";

interface LocationState {
  from?: {
    pathname: string;
  };
}

interface RedirectToDashboardProps {
  children: React.ReactNode;
}

const RedirectToDashboard = ({ children }: RedirectToDashboardProps) => {
  const location = useLocation<LocationState>();
  const { from } = location.state || {};
  const isAuthenticated = useSelector(getIsAuthenticated);

  const isTransporter = useSelector(getIsDefaultRoleTransporter);
  const activeRole = useSelector(getActiveRole);

  const userHasNoActiveRole = activeRole.slug === null;

  const redirectTo = useMemo((): string | null => {
    if (isAuthenticated && !isEmpty(activeRole)) {
      if (from && from.pathname !== "/") {
        return from.pathname;
      }
      if (isTransporter) {
        // Force truckers down the loads route.
        return getLoadsRoute();
      }
      if (!userHasNoActiveRole) {
        return getDashboardRoute();
      }
      return getUserOverviewRoute();
    }
    return null;
  }, [activeRole, from, isAuthenticated, userHasNoActiveRole, isTransporter]);

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return children;
};

export default RedirectToDashboard;
